import { Principle } from '../../types/content';

/** How I work. 제목은 좌우명(해라체 유지), 설명은 합쇼체. 각 원칙은 근거 케이스 하나를 가리킨다. */
export const principles: Principle[] = [
  {
    title: '문제의 본질을 먼저 정의한다',
    description: '요청을 그대로 만들지 않습니다. 그 요청이 어떤 반복 의사결정의 어느 지점인지 먼저 묻습니다.',
    caseId: 'B'
  },
  {
    title: '"현업이 반복해서 쓰는가"가 완성 기준이다',
    description: '구현 완료가 아니라 사용 확산까지가 성과의 범위입니다. 만든 뒤의 전파와 피드백 수용도 일입니다.',
    caseId: 'A'
  },
  {
    title: '기록은 행동을 지배한다',
    description: '결정과 근거를 분리해 남깁니다. 파이프라인도 같습니다. 계약을 보면 누구나 상태를 이해하고 같은 방법으로 복구할 수 있어야 합니다.',
    caseId: 'E'
  },
  {
    title: '의견이 갈리면 사람이 아니라 기준과 경계를 합의한다',
    description: '기술 취향으로 설득하지 않습니다. 판단 기준을 먼저 합의하고, 소유 경계를 새로 그립니다.',
    caseId: 'B'
  },
  {
    title: '동료가 나보다 더 잘하게 만든다',
    description:
      '제가 가진 문맥을 전달해 팀이 더 빠르고 정확하게 움직이게 합니다. 팀의 성과가 개인의 성과보다 커지도록 설계합니다. 사용자 클러스터링 화면도 제 안(데이터 테이블과 필터) 대신 동료들의 안(타깃층 설정과 분포 화면)으로 바꿨고, 그쪽이 맞았습니다.',
    caseId: 'A'
  },
  {
    title: '결론보다 질문을 먼저',
    description: '"왜 이렇게 만드셨나요?"를 먼저 묻습니다. "방향이 틀렸습니다" 같은 단정은 피드백이 아니라 단절입니다.'
  },
  {
    title: '할 수 있는 만큼, 그러나 꾸준히',
    description: '무리해서 얻은 반짝이는 성취보다 무너지지 않고 이어가는 날들을 더 소중히 여깁니다.'
  }
];
